import BarOrderPage from "./BarOrderPage.vue";

export {BarOrderPage}
export default BarOrderPage
